module.exports = __webpack_public_path__ + "statics/img/left-bannner.22f1fa55.jpg";